/**
 * Custom JavaScript
 * Author: Sajeel Shafqat
 * Date: 2026-01-09
 *
 * 
 */


/**
 * Run when HTML loads only.
 */
document.addEventListener('DOMContentLoaded', function(){

});


/**
 * Run when all assets fully load.
 */
window.addEventListener('load', function(){


    // Hides floating email button when the user reaches the bottom of page.
    const EMAIL_ICON = document.querySelector('.floating-contact-btn');
    window.addEventListener('scroll', () => {
        const SCROLL_TOP = window.scrollY;
        const WINDOW_HEIGHT = window.innerHeight;
        const DOC_HEIGHT = document.documentElement.scrollHeight;

        // Check if scrolled to 100% (bottom)
        if (SCROLL_TOP + WINDOW_HEIGHT >= DOC_HEIGHT) {
        EMAIL_ICON.style.display = 'none';
        } else {
        EMAIL_ICON.style.display = 'block';
        }
    });

    
    const SIDE_BUTTON = document.querySelector(".floating-contact-btn");
    let timer;

    // ---------- IDLE HIDE (4 seconds) ----------
    function hideButton() {
        SIDE_BUTTON.classList.add("hidden");
    }

    function showButton() {
        SIDE_BUTTON.classList.remove("hidden");
        resetTimer();
    }

    function resetTimer() {
        clearTimeout(timer);
        timer = setTimeout(hideButton, 2000);
    }

    ["click", "scroll", "mousemove", "touchstart"].forEach(event => {
        window.addEventListener(event, showButton);
    });

    resetTimer();

    // ---------- HIDE AT BOTTOM ----------
    window.addEventListener("scroll", () => {
        const scrollTop = window.scrollY;
        const windowHeight = window.innerHeight;
        const docHeight = document.documentElement.scrollHeight;

        if (scrollTop + windowHeight >= docHeight - 5) {
        SIDE_BUTTON.classList.add("hidden");
        }
    });


});


